module.exports = "/_next/static/images/8f414ec8c1347e6c99cbc296dcd7d1f7-2-woman-working@0.5x.jpg";